import { Injectable } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';

import { EmailReminder } from 'src/app/shared/models/emailReminder';
import { IPagedResult } from 'src/app/shared/models/pagedResult';
import { EmailCustomization, EmailScenario } from '../models/emailCustomization';
import { IEmailMessage } from '../models/emailMessage';
import { BaseService } from './base.service';
import { EmailCustomizationService } from './email-customization.service';

@Injectable()
export class EmailReminderService extends BaseService {
  private basePath = 'email-reminders';
  scheduledEmailContent: string;

  constructor(private emailCustomizationService: EmailCustomizationService) {
    super();
  }

  findReminders(
    pageIndex: number,
    pageSize: number,
    filter?: string
  ): Observable<IPagedResult<EmailReminder>> {
    return this.get<IPagedResult<EmailReminder>>(this.basePath, {
      params: {
        pageIndex: String(pageIndex),
        pageSize: String(pageSize),
        ...(filter ? { filter: filter.trim() } : undefined)
      }
    });
  }

  getScheduledEmails(
    pageIndex: number,
    pageSize: number,
    filter?: string
  ): Observable<IPagedResult<IEmailMessage>> {
    return this.get<IPagedResult<IEmailMessage>>(this.basePath + '/scheduled-emails', {
      params: {
        pageIndex: String(pageIndex),
        pageSize: String(pageSize),
        ...(filter ? { filter: filter.trim() } : undefined)
      }
    });
  }

  fetchScheduledEmailContent(
    teamId: string,
    scenario: EmailScenario
  ): Observable<EmailCustomization> {
    var scheduledEmail;

    var subject = new Subject<EmailCustomization>();
    this.emailCustomizationService
      .getTeamEmailCustomization(teamId, scenario)
      .subscribe((email: EmailCustomization) => {
        scheduledEmail = email;
        subject.next(scheduledEmail);
      });

    return subject.asObservable();
  }

  getTeamInvitationEmailReminders(
    teamId: string,
    positionId: string,
    seatId: string
  ): Observable<EmailReminder[]> {
    if (!this.authService.adminLevelAccess) {
      return of([]);
    }
    const path = `${this.basePath}/${teamId}/positions/${positionId}/seats/${seatId}/email-reminders`;
    return this.get(path);
  }
}
